import api from './api';

const authService = {
  /**
   * Login user with phone/email and password
   * @param {string} identifier - Phone number or email address
   * @param {string} password
   * @returns {Promise} Response from login API
   */
  login: async (identifier, password) => {
    // Check if identifier is a phone number (digits only) or email
    const isPhone = /^\d+$/.test(identifier);
    const payload = isPhone
      ? { phone: identifier, password }
      : { email: identifier, password };

    const response = await api.post('/api/auth/login', payload);
    return response.data;
  },

  /**
   * Logout current user
   * @returns {Promise} Response from logout API
   */
  logout: async () => {
    const response = await api.get('/api/auth/logout');
    return response.data;
  },

  /**
   * Check if user is authenticated
   * @returns {Promise<boolean>} True if authenticated
   */
  checkAuth: async () => {
    try {
      // Make a request to a protected endpoint to check auth status
      await api.get('/api/roles');
      return true;
    } catch (error) {
      return false;
    }
  },
};

export default authService;
